import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { IconButton } from '@hub/button';
import { CrossSmallIcon } from '@hub/icon';
import { jsx as _jsx } from "react/jsx-runtime";

const QuitButton = _ref => {
  let {
    onClickClose,
    sx
  } = _ref;
  return /*#__PURE__*/_jsx(IconButton, {
    sx: _objectSpread({
      background: 'white',
      color: 'licorice',
      '&:hover': {
        color: 'quartz',
        background: 'white'
      }
    }, sx),
    "aria-label": "Close",
    icon: /*#__PURE__*/_jsx(CrossSmallIcon, {
      sx: {
        cursor: 'pointer',
        position: 'absolute',
        width: 'size-icon-sm',
        height: 'size-icon-sm',
        top: 'spacing-sm',
        left: 'spacing-md'
      },
      "data-id": "search-modal-autocomplete_quit-button_QuitButton_CrossSmallIcon"
    }),
    onClick: onClickClose,
    "data-id": "search-modal-autocomplete_quit-button_QuitButton_IconButton"
  });
};

export default QuitButton;